<template>
    <div class="app" :class="showBtn ? '' : 'show'">
        <div class="order-table" ref="orderTable">
            <ux-grid ref="table" widthResize show-overflow="title" :data="tableData" border stripe :height="uxGridHeight" max-height="100%" style="width: 100%" @cell-click="tableCellClick" v-loading="tableLoading" :row-class-name="tableRowClassName">
                <ux-table-column type="index" width="50" align="center" class-name="table-index" resizable>
                    <template slot="header"><span></span></template>
                </ux-table-column>
                <ux-table-column title="操作" align="center" width="80">
                    <template slot-scope="scope">
                        <el-button icon="el-icon-plus" type="text" :style="scope.rowIndex + 1 == tableData.length ? 'color: red' : ''" @click="addRow(scope.rowIndex + 1)"></el-button>
                        <el-button icon="el-icon-copy-document" type="text" @click="copyRow(scope)" style="margin: 0;"></el-button>
                        <el-button icon="el-icon-delete" type="text" style="margin: 0;" @click="deleteRow(scope)"></el-button>
                        <el-tooltip class="item" effect="dark" :content="scope.row.itemName + '在第' + scope.row.mergeIndex + '行已经录入'" placement="right" :enterable="false" offset="20">
                          <el-button v-show="scope.row.isMerge" icon="iconfont icon-hebing" type="text" @click="mergeRow(scope, 'isLargessFormat')" style="margin: 0;"></el-button>
                        </el-tooltip>
                    </template>
                </ux-table-column>
                <ux-table-column title="商品" field="itemName" align="center" resizable min-width="180px">
                    <template slot-scope="scope">
                        <!-- <div v-if="scope.row.isShowItemName && !scope.row.itemID && !scope.row.planID"> -->
                        <div v-if="scope.row.isShowItemName && !scope.row.planID">
                            <select-multiple :select-data="itemName" :optionKey="itemNameOptionKey" :isSlot="true" :isClear="false" :change="(val, row) => { itemNameChange(val, scope, 'isLargessFormat') }" :visible-change="(val, row) => { itemNameVisibleChange(val, scope) }" v-focus @keydown.enter.right.native="itemNameVisibleChange(false, scope, 'isLargessFormat')" @keyup.shift.up.native="tableSelectUpOrDown(scope, scope.column.property, scope.rowIndex - 1)" @keyup.shift.down.native="tableSelectUpOrDown(scope, scope.column.property, scope.rowIndex + 1)">
                                <template #header>
                                    <li class="el-select-group__title" style="color: #000; font-weight: bold; font-size: 14px;">
                                        <span style="width: 300px;display: inline-block;">商品</span>
                                        <span style="width: 100px;display: inline-block;">规格</span>
                                    </li>
                                </template>
                                <template v-slot:default='slotProps'>
                                    <div style="flex: 1; display: flex; align-items: center;">
                                        <span style="width: 300px;text-wrap: initial;word-wrap:break-word;word-break:break-all;white-space:normal;">{{ slotProps.item.itemName }}</span>
                                        <span style="width: 100px;display: inline-block;">{{ slotProps.item.itemSpec }}</span>
                                    </div>
                                </template>
                            </select-multiple>
                        </div>
                        <div v-else>
                            <span>{{ scope.row.itemName }}</span>
                        </div>
                    </template>
                </ux-table-column>
                <ux-table-column title="规格" field="itemSpec" width="100" align="center" resizable></ux-table-column>
                <ux-table-column title="销售形式" field="isLargessFormat" width="80" align="center" resizable>
                    <template slot-scope="scope">
                        <div v-if="scope.row.isShowIsLargessFormat && !scope.row.planID && !scope.row.isDisableDel">
                            <select-multiple :select-data="isLargessFormat" :isClear="false" :change="(val, row) => { isLargessChange(val, scope, 'salUnitQty') }" :visible-change="(val, row) => { isLargessVisibleChange(val, scope) }" v-focus @keydown.enter.right.native="isLargessVisibleChange(false, scope, 'salUnitQty')" @keydown.left.native="isLargessVisibleChange(false, scope, 'itemName')" @keyup.shift.up.native="tableSelectUpOrDown(scope, scope.column.property, scope.rowIndex - 1)" @keyup.shift.down.native="tableSelectUpOrDown(scope, scope.column.property, scope.rowIndex + 1)">
                            </select-multiple>
                        </div>
                        <span v-else @click="tableCellClick(scope.row, { property: 'salUnitQty' })">{{scope.row.isLargessFormat}}</span>
                    </template>
                </ux-table-column>
                <ux-table-column title="数量" field="" align="center" width="140" resizable>
                    <template slot-scope="scope">
                        <div v-if="scope.row.itemName">
                            <span v-show="scope.row.salUnitName">
                                <el-input-number v-if="scope.row.isShowSalUnitQty && !scope.row.planID" style="width: 40px;" v-focus v-model.number="scope.row.salUnitQty" :controls="false" :min="0" :precision="2" :step="0" @blur="numberInputBlur($event, scope, 'salUnitQty')" @keydown.enter.right.native="numberInputBlur('', scope, 'salUnitQty', scope.row.midUnitName ? 'midUnitQty' : (scope.row.salUnitConversion != 1 ? 'invUnitQty' : (scope.row.hideUnitPrice ? 'remark' : 'salUnitPrice')))" @keydown.left.native="numberInputBlur('', scope, 'salUnitQty', 'isLargessFormat')" @keydown.up.native="numberInputBlur('', scope, 'salUnitQty', 'salUnitQty', scope.rowIndex - 1)" @keydown.down.native="numberInputBlur('', scope, 'salUnitQty', 'salUnitQty', scope.rowIndex + 1)"></el-input-number>
                                <span v-else style="min-width: 40px; display: inline-block; text-align: center;" @click="tableCellClick(scope.row, { property: 'salUnitQty' })">{{Number((Number(scope.row.salUnitQty) || 0).toFixedRoundUp(2))}}</span>
                                <span>{{scope.row.salUnitName}}</span>
                            </span>
                            <span v-show="scope.row.midUnitName">
                                <el-input-number v-if="scope.row.isShowMidUnitQty && !scope.row.planID" style="width: 40px;" v-focus v-model.number="scope.row.midUnitQty" :controls="false" :min="0" :precision="2" :step="0" @blur="numberInputBlur($event, scope, 'midUnitQty')" @keydown.enter.right.native="numberInputBlur('', scope, 'midUnitQty', 'invUnitQty')" @keydown.left.native="numberInputBlur('', scope, 'midUnitQty', 'salUnitQty')" @keydown.up.native="numberInputBlur('', scope, 'midUnitQty', 'salUnitQty', scope.rowIndex - 1)" @keydown.down.native="numberInputBlur('', scope, 'midUnitQty', 'salUnitQty', scope.rowIndex + 1)"></el-input-number>
                                <span v-else style="min-width: 40px; display: inline-block; text-align: center;" @click="tableCellClick(scope.row, { property: 'midUnitQty' })">{{Number((Number(scope.row.midUnitQty) || 0).toFixedRoundUp(2))}}</span>
                                <span>{{scope.row.midUnitName}}</span>
                            </span>
                            <span v-show="scope.row.salUnitConversion != 1 && scope.row.invUnitName">
                                <el-input-number v-if="scope.row.isShowInvUnitQty && !scope.row.planID" style="width: 40px;" v-focus v-model.number="scope.row.invUnitQty" :controls="false" :min="0" :precision="2" :step="0" @blur="numberInputBlur($event, scope, 'invUnitQty')" @keydown.enter.right.native="numberInputBlur('', scope, 'invUnitQty', (!scope.row.planID && !scope.row.hideUnitPrice && scope.row.priceRatio != '0') ? 'salUnitPrice' : 'remark')" @keydown.left.native="numberInputBlur('', scope, 'invUnitQty', scope.row.midUnitName ? 'midUnitQty' : 'salUnitQty')" @keydown.up.native="numberInputBlur('', scope, 'invUnitQty', 'salUnitQty', scope.rowIndex - 1)" @keydown.down.native="numberInputBlur('', scope, 'invUnitQty', 'salUnitQty', scope.rowIndex + 1)"></el-input-number>
                                <span v-else style="min-width: 40px; display: inline-block; text-align: center;" @click="tableCellClick(scope.row, { property: 'invUnitQty' })">{{Number((Number(scope.row.invUnitQty) || 0).toFixedRoundUp(2))}}</span>
                                <span>{{scope.row.invUnitName}}</span>
                            </span>
                        </div>
                    </template>
                </ux-table-column>
                <ux-table-column title="单价" field="" align="center" width="140" resizable>
                    <template slot="header">
                        单价<span style="color: #666">(元/单位)</span>
                    </template>
                    <template slot-scope="scope">
                        <div v-if="scope.row.itemName">
                            <span v-show="scope.row.salUnitName">
                                <el-input-number v-if="scope.row.isShowSalUnitPrice && !scope.row.planID && !scope.row.hideUnitPrice && scope.row.priceRatio != '0'" style="width: 40px;" v-focus v-model.number="scope.row.salUnitPrice" :controls="false" :min="0" :precision="4" :step="0" @blur="numberInputBlur($event, scope, 'salUnitPrice')" @change="handleSelect($event, scope, 'salUnitPrice', scope.row.midUnitName ? 'midUnitPrice' : (scope.row.salUnitConversion != 1 ? 'invUnitPrice' : 'remark'))" @keydown.enter.right.native="numberInputBlur('', scope, 'salUnitPrice', scope.row.midUnitName ? 'midUnitPrice' : (scope.row.salUnitConversion != 1 ? 'invUnitPrice' : 'remark'))" @keydown.left.native="numberInputBlur($event, scope, 'salUnitPrice', scope.row.salUnitConversion != 1 ? 'invUnitQty' : (scope.row.midUnitName ? 'midUnitQty' : 'salUnitQty'))" @keyup.shift.up.native="tableSelectUpOrDown(scope, 'salUnitPrice', scope.rowIndex - 1, (i) => { return Boolean(i.itemID && !i.planID && !i.hideUnitPrice && i.priceRatio != '0') })" @keyup.shift.down.native="tableSelectUpOrDown(scope, 'salUnitPrice', scope.rowIndex + 1, (i) => { return Boolean(i.itemID && !i.planID && !i.hideUnitPrice && i.priceRatio != '0') })"></el-input-number>
                                <span v-else style="min-width: 40px; display: inline-block; text-align: center;" @click="tableCellClick(scope.row, { property: 'salUnitPrice' })">{{Number(Number(scope.row.salUnitPrice || 0).toFixedRoundUp(4))}}</span>
                                <span>{{scope.row.salUnitName}}</span>
                            </span>
                            <span v-show="scope.row.midUnitName">
                                <el-input-number v-if="scope.row.isShowMidUnitPrice && !scope.row.planID && !scope.row.hideUnitPrice && scope.row.priceRatio != '0'" style="width: 40px;" v-focus v-model.number="scope.row.midUnitPrice" :controls="false" :min="0" :precision="4" :step="0" @blur="numberInputBlur($event, scope, 'midUnitPrice')" @change="handleSelect($event, scope, 'midUnitPrice', 'invUnitPrice')" @keydown.enter.right.native="numberInputBlur('', scope, 'midUnitPrice', 'invUnitPrice')" @keydown.left.native="numberInputBlur('', scope, 'midUnitPrice', 'salUnitPrice')" @keyup.shift.up.native="tableSelectUpOrDown(scope, 'salUnitPrice', scope.rowIndex - 1, (i) => { return Boolean(i.itemID && !i.planID && !i.hideUnitPrice && i.priceRatio != '0') })" @keyup.shift.down.native="tableSelectUpOrDown(scope, 'salUnitPrice', scope.rowIndex + 1, (i) => { return Boolean(i.itemID && !i.planID && !i.hideUnitPrice && i.priceRatio != '0') })"></el-input-number>
                                <span v-else style="min-width: 40px; display: inline-block; text-align: center;" @click="tableCellClick(scope.row, { property: 'midUnitPrice' })">{{Number(Number(scope.row.midUnitPrice || 0).toFixedRoundUp(4))}}</span>
                                <span>{{scope.row.midUnitName}}</span>
                            </span>
                            <span v-show="scope.row.salUnitConversion != 1 && scope.row.invUnitName">
                                <el-input-number v-if="scope.row.isShowInvUnitPrice && !scope.row.planID && !scope.row.hideUnitPrice && scope.row.priceRatio != '0'" style="width: 40px;" v-focus v-model.number="scope.row.invUnitPrice" :controls="false" :min="0" :precision="4" :step="0" @blur="numberInputBlur($event, scope, 'invUnitPrice')" @change="handleSelect($event, scope, 'invUnitPrice', 'remark')" @keydown.enter.right.native="numberInputBlur('', scope, 'invUnitPrice', 'remark')" @keydown.left.native="numberInputBlur('', scope, 'invUnitPrice', scope.row.midUnitName ? 'midUnitPrice' : 'salUnitPrice')" @keyup.shift.up.native="tableSelectUpOrDown(scope, 'salUnitPrice', scope.rowIndex - 1, (i) => { return Boolean(i.itemID && !i.planID && !i.hideUnitPrice && i.priceRatio != '0') })" @keyup.shift.down.native="tableSelectUpOrDown(scope, 'salUnitPrice', scope.rowIndex + 1, (i) => { return Boolean(i.itemID && !i.planID && !i.hideUnitPrice && i.priceRatio != '0') })"></el-input-number>
                                <span v-else style="min-width: 40px; display: inline-block; text-align: center;" @click="tableCellClick(scope.row, { property: 'invUnitPrice' })">{{Number(Number(scope.row.invUnitPrice || 0).toFixedRoundUp(4))}}</span>
                                <span>{{scope.row.invUnitName}}</span>
                            </span>
                        </div>
                    </template>
                </ux-table-column>
                <ux-table-column field="totalAmt" title="总价" align="center" width="120" resizable>
                    <template slot-scope="scope">
                        <span>{{amt(scope)}}</span>
                    </template>
                </ux-table-column>
                <ux-table-column resizable title="备注" field="remark" align="center" width="150">
                    <template slot-scope="scope">
                        <div v-if="scope.row.isShowRemark">
                            <el-input v-model="scope.row.remark" v-focus @blur="scope.row.isShowRemark = false" @keydown.enter.right.native="remarkEnter($event, scope, 'remark', 'itemName')" @keydown.left.native="remarkEnter($event, scope, 'remark', (!scope.row.planID && !scope.row.hideUnitPrice && scope.row.priceRatio != '0') ? (scope.row.salUnitConversion != 1 ? 'invUnitPrice' : (scope.row.midUnitName ? 'midUnitPrice' : 'salUnitPrice')) : (scope.row.salUnitConversion != 1 ? 'invUnitQty' : (scope.row.midUnitName ? 'midUnitQty' : 'salUnitQty')))" @keyup.up.native="tableSelectUpOrDown(scope, scope.column.property, scope.rowIndex - 1)" @keyup.down.native="tableSelectUpOrDown(scope, scope.column.property, scope.rowIndex + 1)"></el-input>
                        </div>
                        <span v-else>{{scope.row.remark}}</span>
                    </template>
                </ux-table-column>
            </ux-grid>
        </div>
        <div class="footer" v-if="showBtn">
            <span>共<span class="text">{{sum.total}}</span>条, <span class="text" style="font-size: 20px;">{{sum.totalAmt}}</span>元, <span class="text">{{sum.billSalQty}}</span>大<span class="text">{{sum.billMedQty}}</span>中<span class="text">{{sum.billInvQty}}</span>小</span>
            <div>
                <el-button size="medium" @click="submitOrser(0)">保存草稿并新建</el-button>
                <el-button size="medium" v-if="btnPower.isRecord == 'Y'" type="primary" @click="submitOrser(1)">提交审核</el-button>
                <el-button size="medium" @click="clearTable">清空列表</el-button>
            </div>
        </div>
    </div>
</template>
<script>
import { toFixedRe, debounce } from '@/assets/js/common.js'
import { getLastElementForArr, getNextElementForArr, getPrevElementForArr } from '@/assets/js/orderEntering.js'
export default {
    props: {
        from: Object,
        btnPower: Object,
        power: Object,
        showBtn: {
            default: false,
            type: Boolean
        }
    },
    components: {},
    data() {
        return {
            store: this.$store.state,
            tableData: this.pushItem(),
            itemName: {
                submitName: "itemName",
                selected: {},
                valueIsObj: true,
                isMultiple: false,
                isAll: false,
                isShowAll: false,
                isFilterable: true,
                isRemote: true,
                isPagination: true,
                isReSearch: false,
                list: [],
                placeholder: "请选择商品",
                request: {
                    url: "/Account/dataSearchVue/selectItemEnterDetailList.html",
                    type: "post",
                    params: {
                        page: 1,
                        size: 5,
                        billType: 'DHD'
                    },
                    text: "itemName",
                    value: "itemID",
                },
            },
            isLargessFormat: {
                submitName: "isLargessFormat",
                selected: {},
                valueIsObj: true,
                isMultiple: false,
                isAll: false,
                isShowAll: false,
                isFilterable: true,
                isRemote: true,
                isPagination: true,
                isReSearch: false,
                list: [],
                placeholder: "请选择销售形式",
                request: {
                    url: "/Account/dataSearchVue/selectLargessList.html",
                    type: "post",
                    params: {
                        page: 1,
                        size: 5,
                        billType: 'DHD',
                        onlyShowNormalAndLargess: 'Y'
                    },
                },
            },
            tableLoading: false,
            sum: {
                total: 0,
                totalAmt: 0,
                billInvQty: 0,
                billMedQty: 0,
                billSalQty: 0
            },
            viewInv: {
                loading: false,
                tableData: []
            },
            uxGridHeight: 600,
        }
    },
    directives: {
        focus: {
            inserted: function(el) {
                el.querySelector('input').onfocus = function(e) {
                    this.select()
                }
                setTimeout(() => {
                    el.querySelector('input').focus()
                }, 0)
            }
        }
    },
    mounted() {
        this.uxGridHeight = parseInt($('.order-table').css('height')) - 2
        window.onresize = () => {
            this.uxGridHeight = parseInt($('.order-table').css('height')) - 2
        }
    },
    watch: {
        from(val) {
            console.log(val)
            this.itemName.request.params.customerID = val.customerID
            // this.itemName.request.params.firstValue = val.firstValue
            // this.itemName.request.params.secondValue = val.secondValue
        },
        tableData(val) {
            let total = 0,
                amt = 0,
                sal = 0,
                mid = 0,
                inv = 0
            val.forEach((item, index) => {
                item['lineNum'] = index + 1
                if (item.itemID) {
                    item.totalAmt = Number(this.amt({ row: item }))
                    total += 1
                    amt += Number(item.totalAmt || 0)
                    sal += Number(item['salUnitQty'] || 0)
                    mid += Number(item['midUnitQty'] || 0)
                    inv += Number(item['invUnitQty'] || 0)
                }
            })
            this.sum.total = total
            this.sum.totalAmt = Number(toFixedRe(amt, 2))
            this.sum.billInvQty = Number(toFixedRe(inv, 2))
            this.sum.billMedQty = Number(toFixedRe(mid, 2))
            this.sum.billSalQty = Number(toFixedRe(sal, 2))
            if (val[val.length - 1].itemID) {
                this.tableData = this.tableData.concat(this.pushItem(20))
            }
        }
    },
    methods: {
        getProductData() {
            this.$nextTick(() => {
                this.tableData.some((item) => {
                    if (!item.itemName) {
                    console.log(item);
                        this.tableCellClick(item, { property: 'itemName' })
                        return true
                    }
                })
            })
        },
        getHeight() {
            this.uxGridHeight = parseInt($('.order-table').css('height')) - 2
        },
        pushItem(length = 20) {
            const tempItem = []
            for (let i = 0; i < length; i++) {
                tempItem.push({})
            }
            return tempItem
        },
        // 首字母大写
        titleCase(str) {
            return str.replace(/( |^)[a-z]/g, (L) => L.toUpperCase())
        },
        tableCellClick(row, { property }) {
            if (row.itemName || property == 'itemName') {
                if (property && property.match(/itemName|isLargessFormat|salUnitPrice|midUnitPrice|invUnitPrice|salUnitQty|midUnitQty|invUnitQty|remark/i)) {
                    if (!this.from.customerID) return this.$message({
                        showClose: true,
                        message: '请先选择客户',
                        type: 'warning'
                    })
                    if (!this.from.salOrderMeetID) return this.$message({
                        showClose: true,
                        message: '请先选择订货会',
                        type: 'warning'
                    })
                    if (this.showBtn) {
                        if (!this.from.salesmanID) return this.$message({
                            showClose: true,
                            message: '请先选择业务员',
                            type: 'warning'
                        })
                    }
                    if (property == 'itemName') {
                        this.$refs['table'].scrollToRow(row)
                    }
                    setTimeout(() => {
                        this.$set(row, 'isShow' + this.titleCase(property), true)
                        this.$refs['table'].updateData()
                    }, 100)
                }
            }
            this.getPrePayAmt()
        },
        itemNameOptionKey(item) {
            return item.itemID + item.productionDate
        },
        itemNameVisibleChange(val, { row, column }, next) {
            if (!val) {
                if (next) {
                    if (row.itemID) {
                        this.$set(row, 'isShow' + this.titleCase(column.property), false)
                    }
                    this.tableCellClick(row, { property: next })
                } else {
                    this.$set(row, 'isShow' + this.titleCase(column.property), false)
                }
                
            } else {
                this.itemName.placeholder = row.itemName
                this.itemName.selected = { text: row.itemName, value: row.itemID }
                if (column.property == 'itemName') {
                    this.$refs.table.$el.querySelector('.elx-table--body-wrapper').scrollLeft = 0
                    let flag = false
                    console.log(this.$store.state.power.isAgreementDoubleItem)
                    if (this.$store.state.power.isAgreementDoubleItem == 'Y') {
                        flag = this.checkRepeat({}, 'isLargessFormat', true)
                    }
                    if (flag) {
                        this.$set(row, 'isShow' + this.titleCase(column.property), false)
                    }
                }
            }
            this.itemName.request.params.page = 1
        },
        isLargessVisibleChange(val, { row, column, rowIndex: $index, }, next) {
            if (!val) {
                this.$nextTick(() => {
                    console.log(12344);
                    // this.$set(row, 'isShow' + this.titleCase(column.property), false)
                    this.$set(this.tableData[$index], 'isShow' + this.titleCase(column.property), false)
                    // this.tableCellClick(row, { property: 'salUnitQty' })
                    if (next) {
                        this.tableCellClick(this.tableData[$index], { property: next })
                    }
                })
            } else {
                this.isLargessFormat.placeholder = row.isLargessFormat
                this.isLargessFormat.selected = { text: row.isLargessFormat, value: row.isLargess }
            }
            this.isLargessFormat.request.params.page = 1
        },
        async itemNameChange(val, { rowIndex: $index, row }, next) {
            let data = { ...this.tableData[$index], ...val, ...{ amt: 0, salUnitQty: 0, midUnitQty: 0, invUnitQty: 0, hideUnitPrice: val.isLargess.match(/L|D/i) ? true : false  } }
            let flag = this.checkRepeat({ $index, row: data }, next)
            if (next && !flag) {
              this.isLargessFormat.request.params.itemID = val.itemID
              this.isLargessFormat.request.params.customerID = this.from.customerID
              data['isShow' + this.titleCase(next)] = true
            }
            this.$set(this.tableData, $index, data)
          console.log(flag)
          // this.isLargessFormat.request.params.itemID = val.itemID
            // this.isLargessFormat.request.params.customerID = this.from.customerID
            // this.$set(this.tableData, $index, { ...row, ...val })
            this.$set(this.tableData[$index], 'isShowItemName', false)
            return
            let rowIndex = 0
            let tempArr = this.tableData.filter((i, index) => {
                if (this.itemNameOptionKey(i) == this.itemNameOptionKey(val)) {
                    rowIndex = index + 1
                    return true
                }
            })
            let confirmResult = ''
            console.log(tempArr)
            if (tempArr.length) {
                const h = this.$createElement
                confirmResult = await this.$msgbox({
                    title: '提示',
                    message: h('p', null, [
                        h('i', { style: 'color: teal' }, tempArr[0].itemName),
                        h('span', null, '第'),
                        h('i', { style: 'color: #F56C6C' }, rowIndex),
                        h('span', null, '行已经录入，是否合并?')
                    ]),
                    showCancelButton: true,
                    confirmButtonText: '合并',
                    cancelButtonText: '追加',
                    type: 'warning'
                }).catch(err => err)
            }
            console.log(confirmResult)
            if (confirmResult == '' || confirmResult == 'cancel') {
                this.isLargessFormat.request.params.itemID = val.itemID
                this.isLargessFormat.request.params.customerID = this.from.customerID
                this.$set(this.tableData, $index, { ...row, ...val })
                this.$set(this.tableData[$index], 'isShowItemName', false)
                this.tableCellClick(this.tableData[$index], { property: 'isLargessFormat' })
                // console.log(this.tableData)
                // let $queryForm = this.$parent.$children[0]
                // $queryForm.selectProductList = $queryForm.selectProductList.filter(i => this.itemNameOptionKey(i) != this.itemNameOptionKey(row))
                // // $queryForm.selectProductList = $queryForm.selectProductList.filter(i => i.value != row.value)
                // $queryForm.selectProductList.push(val)
            } else if (confirmResult == 'confirm') {
                this.isLargessFormat.request.params.itemID = val.itemID
                this.isLargessFormat.request.params.customerID = this.from.customerID
                this.tableCellClick(tempArr[0], { property: 'salUnitQty' })
            }
        },
        isLargessChange(val, scope, next) {
            let { rowIndex: $index, row } = scope
            console.log(next);
            val.isLargessFormat = val.text
            val.isLargess = val.value
            if (val.value == 'L' || val.value == 'D') { // L表示为赠品
                val.hideUnitPrice = true
            } else {
                val.hideUnitPrice = false
            }
            this.$set(this.tableData, $index, { ...row, ...val })
            this.isLargessVisibleChange(false, scope, next)
        },
        numberInputBlur($event, { row }, property, next, index = null) {
            row['isShow' + this.titleCase(property)] = false
            // this.$set(this.tableData, $index , row)
            this.$refs['table'].updateData()
            if (next) {
                let tempRow = row
                if (index != null) {
                    if (index >= 0) {
                        tempRow = this.tableData[index]
                    } else if (index < 0) {
                        tempRow = this.tableData[getLastElementForArr(this.tableData, 'itemID')]
                    }
                    if (!tempRow.itemID) {
                        next = 'itemName'
                    }
                }
                // if (property == 'remark') {
                //     if (this.tableData[$index + 1]) {
                //         this.tableCellClick(this.tableData[$index + 1], { property: next })
                //     }
                //     return false
                // }
                console.log(tempRow);
                this.tableCellClick(tempRow, { property: next }, index)
            }
        },
        tableSelectUpOrDown({ row, rowIndex: $index }, property, index, key = 'itemID') {
            let idx = index
            if (idx >= 0) {
                if (idx >= this.tableData.length) {
                    idx = 0
                }
            } else if (idx < 0) {
                idx = getLastElementForArr(this.tableData, key)
            }
            if (idx == -1) return false
            if (property == 'salUnitPrice') {
                if (index > $index) {
                    idx = getNextElementForArr(this.tableData, key, idx)
                    if (idx == -1) {
                        idx = getLastElementForArr(this.tableData, 'itemID') + 1
                    }
                } else if (index < $index) {
                    idx = getPrevElementForArr(this.tableData, key, idx)
                    if (idx == -1) {
                        idx = getLastElementForArr(this.tableData, key)
                    }
                }
            }
            this.$set(row, 'isShow' + this.titleCase(property), false)
            if (this.tableData[idx] && !this.tableData[idx].itemID) {
                property = 'itemName'
            }
            this.tableCellClick(this.tableData[idx], { property: property })
        },
        addRow(index) {
            if (index === this.tableData.length) {
                this.tableData = this.tableData.concat(this.pushItem(10))
            } else {
                // this.tableData.push({})
                this.tableData.splice(index, 0, {})
            }
        },
        copyRow({ $index, row, column }) {
            if (!row.itemName) return
            if (row.planID) return this.$message({
                showClose: true,
                message: '促销商品不允许复制',
                type: 'warning'
            })
            this.tableData.some((item, index) => {
                if (index >= $index) {
                    if (!item.itemName) {
                        this.$set(this.tableData, index, { ...row }) // 解决两份数据来源一样时，会使两行同时处于编辑状态的bug({ ...row } 是深度复制，row 是引用，指针相同)
                        return true
                    }
                }
            })
        },
        async deleteRow({ rowIndex: $index, row }) {
            if (this.tableData.length <= 1) return
            const confirmResult = await this.$confirm('此操作为删除操作, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).catch(err => err)
            if (confirmResult !== 'confirm') return this.$message.info('取消删除')
            this.$nextTick(() => {
                // let $queryForm = this.$parent.$children[0]
                // console.log(this.itemNameOptionKey(row))
                // $queryForm.selectProductList = $queryForm.selectProductList.filter(i => this.itemNameOptionKey(i) != this.itemNameOptionKey(row))
                if (row.planID) {
                    this.tableData = this.tableData.filter(item => item.planID != row.planID)
                } else {
                    this.tableData.splice($index, 1)
                }
            })
        },
        async mergeRow ({ rowIndex, row }, next) {
          if (this.tableData.length <= 1) return
          const confirmResult = await this.$confirm('此操作为合并操作, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).catch(err => err)
          if (confirmResult !== 'confirm') return this.$message.info('取消合并')
          let index = row.mergeIndex - 1
          let item = this.tableData[index]
          if (item.itemID == row.itemID) {
            this.$set(this.tableData, rowIndex, {})
            console.log(this.tableData[index])
            this.tableCellClick(this.tableData[index], { property: 'salUnitQty' })
          } else {
            this.checkRepeat({ $index: rowIndex, row }, next)
          }
        },
        clearTable() {
            this.tableData = [].concat(this.pushItem(20))
        },
        remarkEnter(event, { rowIndex: $index, row }, property, next) {
            let index = $index
            if (event.key == 'ArrowRight' || event.key == 'Enter') {
                index = $index + 1
            } else if (event.key == 'ArrowDown') {
                index = $index + 1
                if (this.tableData[index].itemID) {
                    next = property
                }
            } else if (event.key == 'ArrowUp') {
                index = $index - 1
                if (index < 0) {
                    index = getLastElementForArr(this.tableData, 'itemID')
                }
                if (this.tableData[index].itemID) {
                    next = property
                }
            }
            row.isShowRemark = false
            this.tableCellClick(this.tableData[index], { property: next })
        },
        handleSelect(val, scope, property, next) {
            console.log(toFixedRe(35, 4));
            if (next) {
                this.numberInputBlur('', scope, property, next) // 先失焦，在赋值，是为了与mousedown事件保持同样的触发时机；不要改变顺序（除非你可以解决input框blur事件比click先触发的问题）
            }
            let { $index, row } = scope
            if (val) {
                val = toFixedRe(val, 4)
                this.$set(row, property, val)
            }
            this.computeUnitPrice(property, row, $index)
        },
        computeUnitPrice(property, row, $index) {
            let { salUnitPrice, midUnitPrice, invUnitPrice, salUnitConversion, midUnitConversion, invUnitConversion } = row
            if (property == 'salUnitPrice') {
                midUnitPrice = Number(toFixedRe(((Number(salUnitPrice) || 0) / Number(salUnitConversion) * Number(midUnitConversion)), 4)).toString()
                invUnitPrice = Number(toFixedRe(((Number(salUnitPrice) || 0) / Number(salUnitConversion)), 4)).toString()
            } else if (property == 'midUnitPrice') {
                salUnitPrice = Number(toFixedRe(((Number(midUnitPrice) || 0) / Number(midUnitConversion) * Number(salUnitConversion)), 4)).toString()
                invUnitPrice = Number(toFixedRe(((Number(midUnitPrice) || 0) / Number(midUnitConversion)), 4)).toString()
            } else if (property == 'invUnitPrice') {
                salUnitPrice = Number(toFixedRe(((Number(invUnitPrice) || 0) * Number(salUnitConversion)), 4)).toString()
                midUnitPrice = Number(toFixedRe(((Number(invUnitPrice) || 0) * Number(midUnitConversion)), 4)).toString()
            }
            row.salUnitPrice = salUnitPrice
            row.midUnitPrice = midUnitPrice
            row.invUnitPrice = invUnitPrice
            this.$refs['table'].$nextTick(() => {
                this.$set(this.tableData, $index, row)
            })
        },
        submitOrser(params) {
            console.log(this.from)
            let { customerID, salesmanID, salOrderMeetID, remark } = this.from
            if (!customerID) return this.$message({
                showClose: true,
                message: '请先选择客户',
                type: 'warning'
            })
            if (!salOrderMeetID) return this.$message({
                showClose: true,
                message: '请先选择订货会',
                type: 'warning'
            })
            if (!salesmanID) return this.$message({
                showClose: true,
                message: '请先选择业务员',
                type: 'warning'
            })
            if (!this.tableData.length) return this.$message({
                showClose: true,
                message: '请先至少录入一条数据',
                type: 'warning'
            })
            let flag = false
            let tableData = []
            this.tableData.map((i, index) => {
                if (i.itemID) {
                    tableData.push(i)
                }
            })
            tableData.some(item => {
                const { itemID, salUnitQty, midUnitQty, invUnitQty, lineNum } = item
                console.log(itemID, salUnitQty, midUnitQty, invUnitQty)
                if (itemID && Number(salUnitQty) + Number(midUnitQty) + Number(invUnitQty) == 0) {
                    this.$message({
                        showClose: true,
                        message: '第' + lineNum + '行,商品数量不能为零',
                        type: 'error'
                    })
                    flag = true
                    return true
                }
            })
            if (flag) return
            if (params == 1) {
                this.$emit('show-dialog', { customerID: this.from.customerID, itemList: this.tableData.filter(item => item.itemID), totalAmt: this.sum.totalAmt })
            } else {
                this.toSubmit()
            }
        },
        async toSubmit() { //保存草稿
            const loading = this.$loading({
                lock: true,
                text: '保存中，请耐心等待',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            })
            let currTab = '',
                title = ''
            if (top.$('#tabspanel .tabs-selected').text()) {
                currTab = top.$('#tabspanel').tabs('getSelected') || ''
                title = top.$('#tabspanel .tabs-selected').text() || ''
            } else {
                title = top.getTabName() || ''
                currTab = top.getTabName() || ''
            }
            let tableData = []
            this.tableData.map((i, index) => {
                if (i.itemID) {
                    tableData.push(i)
                }
            })
            let params = { ...this.sum, ...this.from }
            params.itemMasterInfo = JSON.stringify(tableData)
            let url = '',
                { tag, billNo } = this.power
            if (tag && tag == 'edit') params.billNo = billNo
            url = tag && tag == 'edit' ? '/Account/salOrderMeetReviewForVue/updateSalOrderMeetReviewForVue.html' : '/Account/salOrderMeetForVue/addSalOrderMeetReviewForVue.html'
            console.log(params)
            console.log(url)
            const { data: res } = await this.$http.post(url, this.Qs.stringify(params))
            loading.close()
            if (res.code != 'success') return this.$message.error(res.message)
            this.$message.success(res.message)
            top.refreshTabWithUrl(`/templates/vue-account/dist/index.htm#/salOrderItemOrder`, currTab)
        },
        // 记账
        async onSubmit({ queryForm, dialogTable, command }) {
            let currTab = '',
                title = ''
            if (top.$('#tabspanel .tabs-selected').text()) {
                currTab = top.$('#tabspanel').tabs('getSelected') || ''
                title = top.$('#tabspanel .tabs-selected').text() || ''
            } else {
                title = top.getTabName()
                currTab = top.getTabName()
            }
            const loading = this.$loading({
                lock: true,
                text: '记账中，请耐心等待',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            })
            let tempItem = {}
            let tableData = []
            let brandArrearAndPrepayList = []
            this.tableData.map((i, index) => {
                if (i.itemID) {
                    tableData.push(i)
                }
            })
            let params = { ...this.sum, ...this.from }
            params.itemMasterInfo = JSON.stringify(tableData)
            let url = '',
                { tag, billNo } = this.power
            if (tag && tag == 'edit') params.billNo = billNo
            url = tag && tag == 'edit' ? '/Account/salOrderMeetForVue/updateSalOrderMeetAndRecordForVue.html' : '/Account/salOrderMeetForVue/addSalOrderMeetAndRecordForVue.html'
            if (this.power.brandArrear == 'N') { // 如果不是分品牌则写死一个综合品牌
                tempItem['brandId'] = 2010010101010000000
                tempItem['brandName'] = '综合品牌'
                tempItem['cashAmt'] = queryForm.payableAmt
                tempItem['discountAmt'] = queryForm.discountAmt
                tempItem['arrearAmt'] = queryForm.arrearAmt
                tempItem['prepayAmt'] = queryForm.prePayAmt
                tempItem['prepayType'] = this.power.splitPayAndReturnPrePay == 'N' ? 0 : queryForm.splitPayAndReturnPrePay
                brandArrearAndPrepayList.push(tempItem)
            } else {
                brandArrearAndPrepayList = dialogTable.map(item => ({ ...item, ...{ brandId: item.financialBrandID, brandName: item.financialBrandName } }))
                brandArrearAndPrepayList = dialogTable.map((item, index, array) => {
                    item['brandId'] = item.financialBrandID
                    item['brandName'] = item.financialBrandName
                    item['prepayType'] = this.power.splitPayAndReturnPrePay == 'N' ? 0 : queryForm.splitPayAndReturnPrePay
                    return item
                })
            }
            // console.log(brandArrearAndPrepayList)
            params = { ...params,
                ...{
                    accountID: queryForm.account.selected ? queryForm.account.selected.value : '',
                    accountName: queryForm.account.selected ? queryForm.account.selected.text : '',
                    othersPayAmt: queryForm.cardAmt,
                    cashsPayAmt: queryForm.cashAmt,
                    payAmt: queryForm.payableAmt, // 实收
                    discountAmt: queryForm.discountAmt, // 折扣
                    prePayAmt: queryForm.prePayAmt, // 预收
                    arrearAmt: queryForm.arrearAmt, // 欠款
                    payMethod: queryForm.payType.value // 收款方式
                }
            }
            params['brandArrearAndPrepayList'] = JSON.stringify(brandArrearAndPrepayList)
            const { data: res } = await this.$http.post(url, this.Qs.stringify(params))
            loading.close()
            if (res.code != 'success') return this.$message.error(res.message)
            this.$message.success(res.message)
            this.$emit('hide-dialog')
            top.refreshTabWithUrl(`/templates/vue-account/dist/index.htm#/salOrderItemOrder`, currTab)
            // this.resetTable()
        },
        tableRowClassName({ row, rowIndex }) {
            if (row.isSearch) {
                return 'search-row'
            }
            return ''
        },
        amt({ row }) {
            let str = ''
            if (row['salUnitQty'] || row['midUnitQty'] || row['invUnitQty']) {
                let sal = (Number(row['salUnitQty']) || 0) * (Number(row['salUnitPrice']) || 0)
                let mid = (Number(row['midUnitQty']) || 0) * (Number(row['midUnitPrice']) || 0)
                let inv = (Number(row['invUnitQty']) || 0) * (Number(row['invUnitPrice']) || 0)
                str = Number(toFixedRe((sal + mid + inv), 2))
                row['totalAmt'] = str
                row['amt'] = str
                if (row.itemName) {
                    if (this.showBtn) {
                        this.getTotal()
                    } else {
                        this.getPrePayAmt()
                    }
                }
            } else {
                row['totalAmt'] = 0
                row['amt'] = 0
            }
            return str
        },
        getPrePayAmt() {
            let amt = 0
            this.tableData.forEach(item => {
                if (item.totalAmt) {
                    amt += item.totalAmt
                }
            })
            this.$emit('getQueryForm', { adjustAmt: amt })
        },
        getTotal() {
            let total = 0,
                amt = 0,
                sal = 0,
                mid = 0,
                inv = 0
            this.tableData.forEach((item, index) => {
                if (item.itemID) {
                    total += 1
                    amt += Number(item.totalAmt || 0)
                    sal += Number(item['salUnitQty'] || 0)
                    mid += Number(item['midUnitQty'] || 0)
                    inv += Number(item['invUnitQty'] || 0)
                }
            })
            this.sum.total = total
            this.sum.totalAmt = Number(toFixedRe(amt, 2))
            this.sum.billInvQty = Number(toFixedRe(inv, 2))
            this.sum.billMedQty = Number(toFixedRe(mid, 2))
            this.sum.billSalQty = Number(toFixedRe(sal, 2))
        },
        addProductToOrder(itemList) {
            let tableData = [...this.tableData].reverse()
            let length = tableData.length
            this.$nextTick(() => {
                tableData.some((item, index) => {
                    if (item.itemID) {
                        itemList.forEach((row, $index) => {
                            this.$set(this.tableData, length - index + $index, row)
                        })
                        return true
                    }
                    if ((this.tableData.length - 1) == index) {
                        itemList.map((row, $index) => {
                            this.$set(this.tableData, $index, row)
                        })
                        return true
                    }
                })
            })
            return true
        },
        checkRepeat({ $index, row }, next, isCheck = false) {
            let flag = false
            const checkFn = ($index, row) => {
                let checked = false
                try {
                    this.tableData.forEach((item, index) => {
                        const h = this.$createElement
                        let htmlNode = [
                            h('i', { style: 'color: teal' }, item.itemName),
                            h('span', null, '第'),
                            h('i', { style: 'color: #F56C6C' }, item.lineNum),
                            h('span', null, '行已经录入，是否合并?')
                        ]
                        if (isCheck) {
                            checked = row.itemID && index != $index && (('' + item.itemID + item.isLargess + item.productionDate + item.flavorID) == ('' + row.itemID + row.isLargess + row.productionDate + row.flavorID))
                            htmlNode.unshift(h('span', null, '行的'))
                            htmlNode.unshift(h('i', { style: 'color: #F56C6C' }, $index + 1))
                            htmlNode.unshift(h('span', null, '第'))
                        } else {
                            checked = row.itemID && index != $index && ((item.itemID) == (row.itemID))
                        }
                        if (checked) {
                            if (this.$store.state.power.isAgreementDoubleItem == 'Y') {
                            flag = true
                            this.$msgbox({
                              title: '提示',
                              message: h('p', null, htmlNode),
                              showCancelButton: !isCheck,
                              confirmButtonText: '合并',
                              cancelButtonText: '追加',
                              type: 'warning'
                            }).then(() => {
                              this.isLargessFormat.request.params.itemID = row.itemID
                              this.isLargessFormat.request.params.customerID = this.from.customerID
                              this.$set(this.tableData, $index, {})
                              this.tableCellClick(this.tableData[index], { property: 'salUnitQty' })
                            }).catch(() => {
                              this.isLargessFormat.request.params.itemID = row.itemID
                              this.isLargessFormat.request.params.customerID = this.from.customerID
                              if (isCheck) {
                                this.$set(this.tableData, $index, {})
                                this.tableCellClick(this.tableData[index], { property: 'salUnitQty' })
                                return false
                              }
                              this.tableCellClick(this.tableData[$index], { property: next })
                            })
                          } else {
                            row.isMerge = true
                            row.mergeIndex = item.lineNum
                            console.log(row)
                            this.$message({
                              showClose: true,
                              message: `${item.itemName}在第${item.lineNum}行已经录入`,
                              type: 'warning'
                            });
                            this.isLargessFormat.request.params.itemID = row.itemID
                            this.isLargessFormat.request.params.customerID = this.from.customerID
                            row['isShow' + this.titleCase(next)] = true
                            // this.tableCellClick(this.tableData[$index], { property: next })
                          }
                            throw item
                        }
                    })
                } catch (e) {}
            }
            if (isCheck) {
                this.tableData.forEach(($$item, $$index) => {
                    checkFn($$index, $$item)
                })
            } else {
                checkFn($index, row)
            }
            return flag
        },
    }
}
</script>
<style lang="less">
    .el-select-group__title + .el-select-dropdown__item {
        height: auto !important;
    }
</style>
<style scoped lang="less">
::v-deep .iconfont.icon-hebing {
  font-size: 14px;
}
.app {
    height: 100%;

    .order-table {
        width: 100%;
        height: calc(100% - 45px - 12px);

        ::v-deep .elx-cell {
            padding: 0;
        }

        ::v-deep .elx-table {

            .elx-body--column,
            .elx-footer--column.col--ellipsis {
                height: 39px;
            }

            .elx-body--column.col--ellipsis>.elx-cell,
            .elx-footer--column.col--ellipsis>.elx-cell {
                max-height: 70px;
                white-space: normal;
                color: #000;
            }

            .table-index {
                font-size: 12px;
            }

            th,
            td,
            .cell {
                padding: 0;
            }

            thead {
                color: #000;
            }

            .qty-wrap {
                border-bottom: 1px solid #EBEEF5;
                display: flex;
                flex-wrap: wrap;
                align-items: center;
                justify-content: center;
            }

            .qty-input {
                width: 40px;

                .el-input__inner {
                    padding: 0;
                    text-align: left;
                }
            }

            .qty {
                display: inline-block;
                min-width: 48px;
                text-align: center;
            }

            .search-row {
                td {
                    background-color: rgba(64, 158, 255, 0.6);
                    color: #fff;
                }
            }

            .el-input-number.is-without-controls .el-input__inner,
            .el-input-number .el-input__inner,
            .el-autocomplete .el-input__inner {
                padding: 0;
                text-align: left;
            }
        }
    }

    &.show {

        .order-table {
            height: calc(100%);
        }
    }

    .footer {
        height: 45px;
        display: flex;
        align-items: center;
        margin: 6px 0;

        span {
            width: calc(50% - 153.22px);

            .text {
                color: #F56C6C;
                padding: 0 4px;
            }
        }

        div {}
    }

    ::v-deep .el-dialog {
        .el-dialog__body {
            padding: 16px 12px 0;
        }

        .el-dialog__footer {
            text-align: center;
        }
    }

    .reference {
        cursor: pointer;
    }

    .reference.highlight label {
        color: #409EFF;
    }
}

.query_btn_group {
    display: flex;

    .el-button {
        margin-left: 6px;
        color: #606266;

        &:hover {
            color: #409EFF;
        }
    }
}

::v-deep.el-select-dropdown__item {
    display: flex;
    align-items: center;
}
</style>